import DocumentLocalStepsModal from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal'
import { WizardData } from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal/types'
import { Folder } from 'modules/documents/hooks/useGetFolders'

interface Props {
  onClose: () => void
  onDeleteFile: (i: number) => void
  onDropFiles: (files: File[]) => void
  onUploadFinished: () => Promise<unknown>
  folders: Folder[]
  isReadOnly: boolean
  featureFlagDocumentFolderPermissionsEnabled: boolean
}

const PersonalFilesStepsModal = ({
  onClose,
  onDeleteFile,
  onDropFiles,
  onUploadFinished,
  isReadOnly,
  folders,
  featureFlagDocumentFolderPermissionsEnabled = false,
}: Props) => {
  const initialData: WizardData = {
    distributionWorkflow: 'personal_files',
    uploadType: 'split',
    folderId: null,
    combineFileName: '',
    numberSplitPages: 1,
    esignatureRequest: false,
    additionalSignersAccessIds: [],
    featureFlagDocumentFolderPermissionsEnabled: featureFlagDocumentFolderPermissionsEnabled,
  }

  return (
    <DocumentLocalStepsModal
      onClose={onClose}
      onDeleteFile={onDeleteFile}
      onDropFiles={onDropFiles}
      onUploadFinished={onUploadFinished}
      isReadOnly={isReadOnly}
      folders={folders}
      wizardData={initialData}
    />
  )
}

export default PersonalFilesStepsModal
